const QuizWordPuzzleSpaceSelectedLetter = () => {
  return <span className={`ml-1 my-1 w-8 h-0 block align-middle`}></span>;
};

export default QuizWordPuzzleSpaceSelectedLetter;
